import { Injectable, OnDestroy } from '@angular/core';
import { UserProfile, UserGroup } from '../model/user-profile';
import { KeycloakInit } from '../../keycloak/keycloak-init';
import { Subscription, Observable, of, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { RestService } from 'src/app/shared/service/rest.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService extends RestService implements OnDestroy {

  private userProfile?: UserProfile;
  private userProfileSubscription = new ReplaySubject<UserProfile>();
  updateUserProfile$ = this.userProfileSubscription.asObservable();

  private updateUserSubscription?: Subscription;

  constructor(http: HttpClient, private keycloak: KeycloakInit) {
    super(http);
    this.updateUserSubscription = keycloak.updateUserProfile$.subscribe(userProfile => this.setUserProfile(userProfile));
  }

  ngOnDestroy(): void {
    this.updateUserSubscription?.unsubscribe();
  }

  getUserProfile?(): UserProfile {
    return this.userProfile;
  }

  getUserId(): string {
    return this.userProfile?.idKeycloak;
  }

  getUserName(): string {
    return this.userProfile?.username;
  }

  private setUserProfile(userProfile: UserProfile): void {
    this.userProfile = userProfile;
    this.userProfileSubscription.next(this.userProfile);
  }

  isService(): boolean {
    return this.userProfile.isService();
  }

  isAdmin(): boolean {
    return this.userProfile.isAdmin();
  }

  isAdminOrService(): boolean {
    return this.isAdmin() || this.isService();
  }

  isMPK(): boolean {
    return this.userProfile.isMPK();
  }

  hasGSMPrivilege(): boolean {
    return this.userProfile.hasGSMPrivilege();
  }

  getUserGroupsIds(): Observable<number[]> {
    if (this.userProfile.groups)
      return of(this.userProfile.groups.map(group => group.groupId));
    else
      return this.loadUserGroups().pipe(
        map(groups => groups.map(group => group.groupId))
      );
  }

  private loadUserGroups(): Observable<UserGroup[]> {
    return this.postAndExtract<UserGroup>(UserGroup, 'api/groups/gwt/fetch')
      .pipe(tap(userGroups => this.userProfile.groups = userGroups));
  }

  isUserHasMinRole(role: string): boolean {
    return this.userProfile?.roles?.indexOf(role) > -1;
  }

  logout(): void {
    void this.keycloak.getKeycloakService().logout(window.location.origin);
  }

}
